"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var productViewLoad_1 = require("./productViewLoad");
var freeAccessSucceesLoad_1 = require("./freeAccessSucceesLoad");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.ProductViewLoadEventNames.ProductViewLoad] = productViewLoad_1.productViewLoad,
    _a[analytics_layer_1.ProductViewLoadEventNames.FreeProductViewLoad] = productViewLoad_1.productViewLoad,
    _a[analytics_layer_1.ProductViewLoadEventNames.FreeAccessSuccess] = freeAccessSucceesLoad_1.freeAccessSuccessLoad,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
